import { render, staticRenderFns } from "./RecipeTags.vue?vue&type=template&id=46b40e62&"
import script from "./RecipeTags.vue?vue&type=script&lang=js&"
export * from "./RecipeTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports